import { render, staticRenderFns } from "./TikTokImage.vue?vue&type=template&id=5514f07e&functional=true&"
import script from "./TikTokImage.vue?vue&type=script&lang=js&"
export * from "./TikTokImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports